import React, { useState, useEffect } from "react";
import $ from "jquery";
import * as R from "ramda";

import { ConnectionTypes, CommonServices, PersonalServices, AuxiliarOptions, OtherService, convertBackEndServiceTypesToFrontEndServiceType } from "../../../../../constants/utils/connectionTypes";

import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

import { ModalValidation } from "../../../../facilita/dossier/_common/modalValidation";
import { ModalCommencer } from "../../../../facilita/dossier/_common/modalCommencer";
import { DashboardCard } from "./dashboardCard";
import { ServicesEdit } from "../../../../facilita/dossier/_common/serviceEdit";

import { Path } from "./../_common/path";
import {TerminateModal} from "./terminateModal";

export const RelocationDashboard = ({ serviceDatas, declaration, userLetters, files, userId, relocationDate, isLoading, connectionTypes, declaringUserId, currentlyConnectedUserId, relocatedUser, onDelete, isLoadingDelete, onRestart }) => {
	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
	}, []);

	const [isLoadingLetters, setIsLoadingLetter] = useState([]);
	const [popupText, setPopupText] = useState({ text: "", lastShownPopup: 0 });
	const [selectedService, setSelectedService] = useState(undefined);
	const [orderBy, setOrderBy] = useState("mostRecent");
	const [searchFilter, setSearchFilter] = useState("");
	const [tilesValues, setTilesValues] = useState({
		before15Days: { total: [], toBeHandled: [] },
		before1Month: { total: [], toBeHandled: [] },
		before3Months: { total: [], toBeHandled: [] },
		in8Days: { total: [], toBeHandled: [] },
	});

	//We should get it from backend!
	function service(title, icon, progress, sendingLimitDate, mostRecentDate, serviceDatas, hasBeenValidated) {
		return { title: title, icon: icon, sendingLimitDate: sendingLimitDate, mostRecentDate: mostRecentDate, progress: progress === undefined ? 0 : progress, serviceDatas: serviceDatas, hasBeenValidated: hasBeenValidated };
	}

	const [userServices, setUserServices] = useState([]);

	const dateBefore3Months = new Date(relocationDate);
	dateBefore3Months.setDate(dateBefore3Months.getDate() - 89);

	const dateBefore1Month = new Date(relocationDate);
	dateBefore1Month.setDate(dateBefore1Month.getDate() - 29);

	const dateBefore15Days = new Date(relocationDate);
	dateBefore15Days.setDate(dateBefore15Days.getDate() - 14);

	const dateIn8Days = new Date(relocationDate);
	dateIn8Days.setDate(dateIn8Days.getDate() + 9);

	useEffect(() => {
		const allServices = Object.values(PersonalServices).concat(Object.values(AuxiliarOptions)).concat(Object.values(CommonServices)).concat(Object.values(OtherService));
		let services = [];
		serviceDatas.map((serviceData) => {
			let connectionType = convertBackEndServiceTypesToFrontEndServiceType(serviceData.serviceType);

			let appService = allServices.find((obj) => obj.connectionType === connectionType);

			const s = services.find((s) => s.title === appService.title);

			const lettersForService = userLetters.filter((l) => l.userServiceId === serviceData.id);
			const hasBeenValidated = lettersForService.find((l) => l.letterProgressStage === "Created") === undefined;

			if (!R.isNil(appService) && R.isNil(s)) {
				let mostRecentDate = "";

				if (!R.isEmpty(lettersForService)) {
					lettersForService.sort((a, b) => (a.sendingLimitDate < b.sendingLimitDate ? -1 : a.sendingLimitDate > b.sendingLimitDate ? 1 : 0));
					mostRecentDate = lettersForService[0].sendingLimitDate;
					if (lettersForService[0].letterProgressStage !== "Created") {
						mostRecentDate = lettersForService[0].letterHistory.find((l) => l.letterProgressStage === "Validated" || l.letterProgressStage === "Abandonned").date;
					}

					services.push(service(appService.title, appService.icon, 0, lettersForService[0].sendingLimitDate, mostRecentDate, [serviceData], hasBeenValidated));
				}
			} else {
				if (s.hasBeenValidated === true && hasBeenValidated === false) {
					s.hasBeenValidated = hasBeenValidated;
					s.mostRecentDate = lettersForService[0].sendingLimitDate;
				}

				s.serviceDatas.push(serviceData);
			}
		});
		if (orderBy === "mostRecent") {
			services.sort((a, b) => (a.sendingLimitDate < b.sendingLimitDate ? -1 : a.sendingLimitDate > b.sendingLimitDate ? 1 : 0));
		} else {
			services.sort((a, b) => (a.title < b.title ? -1 : a.title > b.title ? 1 : 0));
		}

		// if(searchFilter !== ""){
		// 	services = services.filter(s => s.title.toLowerCase().indexOf(searchFilter.toLowerCase()) > -1);
		// }
		setUserServices(services);
	}, [serviceDatas, orderBy, searchFilter, userLetters]);

	useEffect(() => {
		// if (userServices.length === 0) return;

		// if (userServices.every((s) => s.hasBeenValidated === false)) {
		// 	setPopupText({ text: "Vous avez quattre sections de délai, vous devez commencer par valider les courriers à transmettre jusqu'à 3 mois avant la date d'effet du déménagement.", lastShownPopup: 1 });
		// 	if (popupText.lastShownPopup < 1) $("#commencerReferent").modal("show");
		// }
		// if (userServices.filter((s) => s.hasBeenValidated).length === 1) {
		// 	if (relocatedUser.hasDocumentSending) {
		// 		setPopupText({ text: "Vous pouvez suivre vos courriers envoyés en recommandé en cliquant sur les cases validées.", lastShownPopup: 2 });
		// 	} else {
		// 		setPopupText({ text: "Vous pouvez télécharger vos courriers à envoyer en cliquant sur les cases validées.", lastShownPopup: 2 });
		// 	}
		// 	if (popupText.lastShownPopup < 2) $("#commencerReferent").modal("show");
		// }

		// if (userServices.filter((s) => new Date(s.sendingLimitDate) <= dateBefore3Months && s.hasBeenValidated === true).length === 4) {
		// 	setPopupText({ text: "INFO : Vous avez un espace bibliothèque mis à disposition qui vous permet de transmettre tous les documents que vous aurez sélectionné de façon simple et sécurisée à vos interlocuteurs (membres de la famille, notaire…).", lastShownPopup: 3 });
		// 	if (popupText.lastShownPopup < 3) $("#commencerReferent").modal("show");
		// }

		// if (userServices.filter((s) => new Date(s.sendingLimitDate) <= dateBefore3Months).every((s) => s.hasBeenValidated === true) && userServices.filter((s) => new Date(s.sendingLimitDate) <= dateBefore1Month).every((s) => s.hasBeenValidated === false)) {
		// 	setPopupText({ text: "Bravo! Tous les courriers devant être transmis aux organismes jusqu'à 3 mois avant la date d'effet du déménagement ont été validés. Veuillez maintenant valider les démarches à faire 1 mois avant.", lastShownPopup: 4 });
		// 	if (popupText.lastShownPopup < 4) $("#commencerReferent").modal("show");
		// }

		// if (userServices.filter((s) => new Date(s.sendingLimitDate) <= dateBefore1Month).every((s) => s.hasBeenValidated === true) && userServices.filter((s) => new Date(s.sendingLimitDate) <= dateBefore15Days).every((s) => s.hasBeenValidated === false)) {
		// 	setPopupText({ text: "Bravo! Tous les courriers devant être transmis aux organismes jusqu'à 1 mois avant la date d'effet du déménagement ont été validés. Veuillez maintenant valider les démarches à faire 15 jours avant.", lastShownPopup: 5 });
		// 	if (popupText.lastShownPopup < 5) $("#commencerReferent").modal("show");
		// }

		// if (userServices.filter((s) => new Date(s.sendingLimitDate) <= dateBefore15Days).every((s) => s.hasBeenValidated === true) && userServices.filter((s) => new Date(s.sendingLimitDate) > dateIn8Days).every((s) => s.hasBeenValidated === false)) {
		// 	setPopupText({ text: "Vous avez validé la section de documents à envoyer dans les 15 jours. Enfin, pour terminer les démarches, vous devez valider les courriers à faire dans les 8 jours après le déménagement.", lastShownPopup: 6 });
		// 	if (popupText.lastShownPopup < 6) $("#commencerReferent").modal("show");
		// }

		// if (userServices.length > 0 && userServices.every((s) => s.hasBeenValidated === true)) {
		// 	setPopupText({ text: "Votre dossier d’accompagnement dans les démarches administratives est finalisé, il reste disponible pour vous et vos proches pendant 1 an ainsi que tous les documents dans l’espace bibliothèque.", lastShownPopup: 7 });
		// 	if (popupText.lastShownPopup < 7) $("#commencerReferent").modal("show");
		// }

		const servicesToDisplay = userServices.filter((s) => s.title.toLowerCase().indexOf(searchFilter.toLowerCase()) > -1);

		const before15Days = { total: [], toBeHandled: [] };
		const before1Month = { total: [], toBeHandled: [] };
		const before3Months = { total: [], toBeHandled: [] };
		const in8Days = { total: [], toBeHandled: [] };

		before3Months.total = servicesToDisplay.filter((s) => new Date(s.sendingLimitDate) <= dateBefore3Months);
		before3Months.toBeHandled = before3Months.total.filter((u) => u.hasBeenValidated === false);

		before1Month.total = servicesToDisplay.filter((s) => new Date(s.sendingLimitDate) <= dateBefore1Month && new Date(s.sendingLimitDate) > dateBefore3Months);
		before1Month.toBeHandled = before1Month.total.filter((u) => u.hasBeenValidated === false);

		before15Days.total = servicesToDisplay.filter((s) => new Date(s.sendingLimitDate) <= dateBefore15Days && new Date(s.sendingLimitDate) > dateBefore1Month);
		before15Days.toBeHandled = before15Days.total.filter((s) => s.hasBeenValidated === false);

		in8Days.total = servicesToDisplay.filter((s) => new Date(s.sendingLimitDate) <= dateIn8Days && new Date(s.sendingLimitDate) > dateBefore15Days);
		in8Days.toBeHandled = in8Days.total.filter((s) => s.hasBeenValidated === false);

		setTilesValues({
			before15Days: before15Days,
			before1Month: before1Month,
			before3Months: before3Months,
			in8Days: in8Days,
		});
	}, [userServices]);

	const servicesToHandle = [tilesValues.before3Months.toBeHandled.length, tilesValues.before1Month.toBeHandled.length, tilesValues.before15Days.toBeHandled.length, tilesValues.in8Days.toBeHandled.length].reduce((a, b) => a + b, 0);
	const servicesTotal = [tilesValues.before3Months.total.length, tilesValues.before1Month.total.length, tilesValues.before15Days.total.length, , tilesValues.in8Days.toBeHandled.length].reduce((a, b) => a + b, 0);

	const servicesToDisplay = userServices.filter((s) => s.title.toLowerCase().indexOf(searchFilter.toLowerCase()) > -1);

	return (
		<article className="view-calc mb-auto flex-md-row align-items-center gap-xs flex-wrap">
			<div className="container-fluid d-flex flex-wrap flex-xl-nowrap justify-content-between align-items-center">
				<Path relocatedUser={relocatedUser} declaration={declaration} userLetters={userLetters} />
				<div className="d-flex gap-2 ml-auto">
					<button type="button" className="btn btn-faded align-self-center my-sm" onClick={onRestart}>
						Redémarrer la déclaration
					</button>
					<button type="button" className="btn btn-primary align-self-center shadow-xs my-sm" data-toggle="modal" data-target="#terminateDeclaration">
						Clôturer dossier de déménagement
					</button>
				</div>
			</div>

			<div className="container-fluid">
				<header className="rounded-bottom-left-sm rounded-top-right-sm mb-2">
					<h2 className="sr-only visually-hidden">Status</h2>
					<div className="grid grid-sm-narrow grid-md-base grid-xl-auto grid-hd-4 gy-2">
						<div className="block">
							<div className="media">
								<div className="media-progress mr-3">
									<CircularProgressbar
										value={tilesValues.before3Months.total.length === tilesValues.before3Months.toBeHandled.length ? 0 : (tilesValues.before3Months.total.length - tilesValues.before3Months.toBeHandled.length) / tilesValues.before3Months.total.length}
										minValue={0}
										maxValue={1}
										background={true}
										styles={buildStyles({
											backgroundColor: "#00000011",
										})}
										text={tilesValues.before3Months.total.length === tilesValues.before3Months.toBeHandled.length ? "0" : (tilesValues.before3Months.total.length - tilesValues.before3Months.toBeHandled.length).toString()}
									/>
								</div>
								<div className="media-body my-auto text-truncate">
									<h3 className="h5 fs-xl-auto fs-hd-root o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Jusqu'à 3 mois avant</h3>
									<p className="h3 text-dark font-weight-bolder lh-solid mb-0">{tilesValues.before3Months.toBeHandled.length === 0 ? (tilesValues.before3Months.total.length === 0 ? "0" : "Fait") : tilesValues.before3Months.toBeHandled.length}</p>
								</div>
							</div>
						</div>
						<div className="block">
							<div className="media">
								<div className="media-progress mr-3">
									<CircularProgressbar
										value={tilesValues.before1Month.total.length === tilesValues.before1Month.toBeHandled.length ? 0 : (tilesValues.before1Month.total.length - tilesValues.before1Month.toBeHandled.length) / tilesValues.before1Month.total.length}
										minValue={0}
										maxValue={1}
										background={true}
										styles={buildStyles({
											backgroundColor: "#00000011",
										})}
										text={tilesValues.before1Month.total.length === tilesValues.before1Month.toBeHandled.length ? "0" : (tilesValues.before1Month.total.length - tilesValues.before1Month.toBeHandled.length).toString()}
									/>
								</div>
								<div className="media-body my-auto text-truncate">
									<h3 className="h5 fs-xl-auto fs-hd-root o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Jusqu'à 1 mois avant</h3>
									<p className="h3 text-dark font-weight-bolder lh-solid mb-0">{tilesValues.before1Month.toBeHandled.length === 0 ? (tilesValues.before1Month.total.length === 0 ? "0" : "Fait") : tilesValues.before1Month.toBeHandled.length}</p>
								</div>
							</div>
						</div>
						<div className="block">
							<div className="media">
								<div className="media-progress mr-3">
									<CircularProgressbar
										value={tilesValues.before15Days.total.length === tilesValues.before15Days.toBeHandled.length ? 0 : (tilesValues.before15Days.total.length - tilesValues.before15Days.toBeHandled.length) / tilesValues.before15Days.total.length}
										minValue={0}
										maxValue={1}
										background={true}
										styles={buildStyles({
											backgroundColor: "#00000011",
										})}
										text={tilesValues.before15Days.total.length === tilesValues.before15Days.toBeHandled.length ? "0" : (tilesValues.before15Days.total.length - tilesValues.before15Days.toBeHandled.length).toString()}
									/>
								</div>
								<div className="media-body my-auto text-truncate">
									<h3 className="h5 fs-xl-auto fs-hd-root o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Jusqu'à 15 jours avant</h3>
									<p className="h3 text-dark font-weight-bolder lh-solid mb-0">{tilesValues.before15Days.toBeHandled.length === 0 ? (tilesValues.before15Days.total.length === 0 ? "0" : "Fait") : tilesValues.before15Days.toBeHandled.length}</p>
								</div>
							</div>
						</div>
						<div className="block">
							<div className="media">
								<div className="media-progress mr-3">
									<CircularProgressbar
										value={tilesValues.in8Days.total.length === tilesValues.in8Days.toBeHandled.length ? 0 : (tilesValues.in8Days.total.length - tilesValues.in8Days.toBeHandled.length) / tilesValues.in8Days.total.length}
										minValue={0}
										maxValue={1}
										background={true}
										styles={buildStyles({
											backgroundColor: "#00000011",
										})}
										text={tilesValues.in8Days.total.length === tilesValues.in8Days.toBeHandled.length ? "0" : (tilesValues.in8Days.total.length - tilesValues.in8Days.toBeHandled.length).toString()}
									/>
								</div>
								<div className="media-body my-auto text-truncate">
									<h3 className="h5 fs-xl-auto fs-hd-root o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Jusqu'à 8 jours après</h3>
									<p className="h3 text-dark font-weight-bolder lh-solid mb-0">{tilesValues.in8Days.toBeHandled.length === 0 ? (tilesValues.in8Days.total.length === 0 ? "0" : "Fait") : tilesValues.in8Days.toBeHandled.length}</p>
								</div>
							</div>
						</div>
						<div className="block">
							<svg style={{ height: 0, position: "absolute" }}>
								<defs>
									<linearGradient id={"prime"} gradientTransform={`rotate(${90})`}>
										<stop offset="0%" stopColor={"#7c3761"} />
										<stop offset="100%" stopColor={"#4771a5"} />
									</linearGradient>
									<linearGradient id={"idCSS"} gradientTransform={`rotate(${90})`}>
										<stop offset="0%" stopColor={"#64CAB0"} />
										<stop offset="100%" stopColor={"#00BCFF"} />
									</linearGradient>
								</defs>
							</svg>
							<div className="media">
								<div className="media-progress mr-3" id="prime">
									<CircularProgressbar
										value={servicesToHandle === servicesTotal ? 0 : (servicesTotal - servicesToHandle) / servicesTotal}
										minValue={0}
										maxValue={1}
										background={true}
										styles={buildStyles({
											// Customize the text
											textColor: "#995D81",
											text: {
												opacity: "1",
											},
											pathColor: "url('#prime')",
											backgroundColor: "#995D8120",
										})}
										text={servicesToHandle === servicesTotal ? "0" : (servicesTotal - servicesToHandle).toString()}
									/>
								</div>
								<div className="media-body my-auto text-truncate">
									<h3 className="h5 fs-xl-auto fs-hd-aux o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Courriers à valider</h3>
									<p className="h3 text-dark font-weight-bolder lh-solid mb-0">{servicesToHandle}</p>
								</div>
							</div>
						</div>
					</div>
				</header>
				<div className="auto-view py-3 pb-lg-0">
					<div className="container-fluid">
						<section className="block mb-4">
							<div className="grid grid-1 grid-md-3 align-items-center mt-2">
								{relocatedUser.hasDocumentSending ? (
									<h2 className="h5 lh-copy text-uppercase font-weight-bolder my-auto grid-column-2">valider les documents nécessaires pour que nous puissions les envoyer :</h2>
								) : (
									<h2 className="h5 lh-copy text-uppercase font-weight-bolder my-auto grid-column-2">valider les documents nécessaires pour pouvoir les télécharger :</h2>
								)}
							</div>
							<nav className="navbar navbar-expand-sm navbar-light px-0 my-2">
								<button className="btn btn-icon alert-secondary navbar-toggler border-0 mb-2 rounded-max py-2 o-80 o-100--hover" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
									<span className="text-secondary eva eva-funnel-outline my-auto lh-1 fs-4"></span>
									<span className="h6 my-auto o-70 mx-2">Filtre</span>
								</button>
								<div className="nav navbar-inline navbar-collapse collapse" id="navbarNav">
									<form className="form-inline mx-auto">
										<div className="my-1 input-group btn-dim rounded-max mr-2">
											<input type="text" className="form-control bg-none rounded-inherit border-none no-focus shadow-none" placeholder="Recherche" aria-label="Recherche" onChange={(e) => setSearchFilter(e.target.value)} />
											<div className="input-group-prepend rounded-inherit">
												<button type="button" className="input-group-text btn btn-icon bg-dim border-left-0 border-none rounded-inherit m-1 w-4">
													<i className="eva eva-search-outline align-middle fs-root lh-0"></i>
												</button>
											</div>
										</div>
										{/* <div className="divider-vertical mx-3"></div>
										<button type="button" className="btn btn-white-info rounded-max p-0 mr-2" data-toggle="modal" data-target="#servicesEdit">
											<p className="form-control my-auto small">Ajouter plus de services</p>
											<div className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4">
												<i className="eva eva-plus-outline align-middle fs-root lh-xs"></i>
											</div>
										</button> */}
									</form>
								</div>
							</nav>
							<section className="block mb-4">
								<div className="flex-row align-items-center mb-0">
									<h2 className="h6 text-uppercase text-warning font-weight-bolder my-auto">Important :</h2>
								</div>
								<form className="grid grid-sm-min grid-lg-tight grid-lg-4 grid-xl-demarche py-sm">
									{servicesToDisplay
										.filter((s) => s.title === "assurance habitation")
										.map((s, index) => {
											return <DashboardCard userService={s} index={index} key={"card_" + s.title} setSelectedService={setSelectedService} userLetters={userLetters} isLoadingLetters={isLoadingLetters} hasDocumentSending={relocatedUser.hasDocumentSending} />;
										})}
								</form>
							</section>
							<section className="block mb-4">
								<div className="flex-row align-items-center mb-0">
									<h2 className="h6 text-uppercase text-secondary font-weight-bolder my-auto">À envoyer jusqu'à 3 mois avant le déménagement: </h2>
								</div>
								<form className="grid grid-sm-min grid-lg-tight grid-lg-4 grid-xl-demarche py-sm">
									{servicesToDisplay
										.filter((s) => new Date(s.sendingLimitDate) <= dateBefore3Months)
										.map((s, index) => {
											return <DashboardCard userService={s} index={index} key={"card_" + s.title} setSelectedService={setSelectedService} userLetters={userLetters} isLoadingLetters={isLoadingLetters} hasDocumentSending={relocatedUser.hasDocumentSending} />;
										})}
								</form>
							</section>
							<section className="block mb-4">
								<div className="flex-row align-items-center mb-0">
									<h2 className="h6 text-uppercase text-secondary font-weight-bolder my-auto">À envoyer jusqu'à 1 mois avant le déménagement: </h2>
								</div>

								<form className="grid grid-sm-min grid-lg-tight grid-lg-4 grid-xl-demarche py-sm">
									{servicesToDisplay
										// .filter((s) => new Date(s.sendingLimitDate) <= dateBefore1Month && new Date(s.sendingLimitDate) > dateBefore3Months && s.title !== "assurance habitation")
										.filter((s) => new Date(s.sendingLimitDate) <= dateBefore1Month && new Date(s.sendingLimitDate) > dateBefore3Months)
										.map((s, index) => {
											return <DashboardCard userService={s} index={index} key={"card_" + s.title} setSelectedService={setSelectedService} userLetters={userLetters} isLoadingLetters={isLoadingLetters} hasDocumentSending={relocatedUser.hasDocumentSending} />;
										})}
								</form>
							</section>
							<section className="block mb-4">
								<div className="flex-row align-items-center mb-0">
									<h2 className="h6 text-uppercase text-secondary font-weight-bolder my-auto">À envoyer jusqu'à 15 jours avant le déménagement:</h2>
								</div>
								<form className="grid grid-sm-min grid-lg-tight grid-lg-4 grid-xl-demarche py-sm">
									{servicesToDisplay
										.filter((s) => new Date(s.sendingLimitDate) <= dateBefore15Days && new Date(s.sendingLimitDate) > dateBefore1Month)
										.map((s, index) => {
											return <DashboardCard userService={s} index={index} key={"card_" + s.title} setSelectedService={setSelectedService} userLetters={userLetters} isLoadingLetters={isLoadingLetters} hasDocumentSending={relocatedUser.hasDocumentSending} />;
										})}
								</form>
							</section>
							<section className="block mb-4">
								<div className="flex-row align-items-center mb-0">
									<h2 className="h6 text-uppercase text-secondary font-weight-bolder my-auto">À envoyer jusqu'à 8 jours après le déménagement:</h2>
								</div>
								<form className="grid grid-sm-min grid-lg-tight grid-lg-4 grid-xl-demarche py-sm">
									{servicesToDisplay
										.filter((s) => new Date(s.sendingLimitDate) <= dateIn8Days && new Date(s.sendingLimitDate) > dateBefore15Days)
										.map((s, index) => {
											return <DashboardCard userService={s} index={index} key={"card_" + s.title} setSelectedService={setSelectedService} userLetters={userLetters} isLoadingLetters={isLoadingLetters} hasDocumentSending={relocatedUser.hasDocumentSending} />;
										})}
								</form>
							</section>
						</section>

						<ServicesEdit activeUserConnections={connectionTypes} serviceDatas={serviceDatas} isLoading={isLoading} userId={userId} displayComments={true} disableModifications={true} />
						<ModalValidation
							service={selectedService}
							userLetters={userLetters}
							serviceDatas={serviceDatas}
							files={files}
							userId={userId}
							isLoading={isLoading}
							setIsLoadingLetter={setIsLoadingLetter}
							isLoadingLetters={isLoadingLetters}
							declaringUserId={declaringUserId}
							currentlyConnectedUserId={currentlyConnectedUserId}
							hasDocumentSending={relocatedUser.hasDocumentSending}
							relocationData={declaration}
						/>
						<ModalCommencer text={popupText.text} />
						<TerminateModal onDelete={onDelete} isLoading={isLoadingDelete}></TerminateModal>
					</div>
				</div>
			</div>
		</article>
	);
};
